<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader @custom-event="getToken"></cnHeader>
		<!--Banner-开始-->
		<div class="banner">
			
			<div class="swiper-cont mySwiper wow animate__animated animate__fadeIn">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in bannerList" :key="index">
						<!--slogan-开始-->
						<div class="slogan">
							<h1>{{item.Title}}</h1>
							<h4>{{item.SubTitle}}</h4>
						</div>
						<!--slogan-结束-->
						<img :src="item.Picture" class="img-cont" />
					</div>
				</div>
				<div class="swiper-pagination"></div>
			</div>
			
		</div>
		<!--Banner-结束-->
		
		<!--搜索-开始-->
		<div class="search_box">
			<h3>快捷检索</h3>
			<div class="search">
				<div class="place">
					<el-input
					  placeholder="请输入您感兴趣的内容"
					  v-model="keyword"
					  maxlength="50"
					  ref="keyword">
					</el-input>
				</div>
				<el-tooltip class="item" effect="dark" :content="keyword==''?tips:'点击开始检索'" placement="right">
				<div class="button" @click="searchHandle()"></div>
				</el-tooltip>
			</div>
		</div>
		<!--搜索-结束-->		
		
		<!--套餐-开始-->
		<div class="product_div">
			<div class="pub_div pub_title_box">
				<div class="left_box">
					<h3>推荐旅游套餐</h3>
					<p>畅享当地美食、人文、海洋世界等多样化服务模式。</p>
				</div>
				<div class="right_box"><a href="/cn/product" class="more">查看全部套餐</a></div>
			</div>
			
			<div class="pub_div product_box">
				<div class="item" v-for="(item,index) in productList" :key="index">
					<a :href="'/cn/product/detail?Id='+item.ProductId" target="_blank" :title="item.Title">
						<div class="tips">{{item.StrockDays}}</div>
						<img :src="item.Picture" />
						<h4>{{truncatedMessage(item.Title,38)}}</h4>
					</a>
					<p>{{replaceTxt(item.Location)}}</p>
				</div>
			</div>
			
		</div>
		<!--套餐-结束-->
		
		<!--玩乐-开始-->
		<div class="recreation_div">
			
			<div class="pub_div pub_title_box">
				<div class="left_box">
					<h3>精选玩乐项目</h3>
					<p>一天时间精选经典景点，行程紧凑但不赶路。中文导游全程讲解，深入了解夏威夷历史与文化。</p>
				</div>
				<div class="right_box"><a href="/cn/recreation" class="more">查看全部玩乐</a></div>
			</div>
			
			<div class="pub_div recreation_box">
				<div class="item" v-for="(item,index) in recreationList" :key="index">
					<a :href="'/cn/recreation/detail?Id='+item.RecreationId" target="_blank" :title="item.Title">
						<el-image
						style="width: 100%; height: 220px;border-top-left-radius: 20px;border-top-right-radius: 20px;"
						:src="item.Picture"
						fit="cover"></el-image>
						
						<h4>{{truncatedMessage(item.Title,30)}}</h4>
					</a>
					<p>{{replaceTxt(item.Location)}}</p>
				</div>
			</div>
		</div>
		<!--玩乐-结束-->
		
		<!--酒店-开始-->
		<div class="hotel_div">
			
			<div class="pub_div pub_title_box">
				<div class="left_box">
					<h3>尊享酒店住宿</h3>
					<p>根据客人预算、位置与需求推荐合适酒店。协助完成酒店预订与确认，流程简单方便。</p>
				</div>
				<div class="right_box"><a href="/cn/hotel" class="more">查看全部酒店</a></div>
			</div>
			
			<div class="pub_div hotel_box">
				<div class="item" v-for="(item,index) in hotelList" :key="index">
					<a :href="'/cn/hotel/detail?Id='+item.HotelId" target="_blank" :title="item.Title">
					<div class="picture">
						<img :src="item.Picture" />
					</div>
					<div class="title">{{truncatedMessage(item.Title,30)}}</div>
					</a>
				</div>
			</div>
			
		</div>
		<!--酒店-结束-->
		
		<!--门票-开始-->
		<div class="ticket_div">
			
			<div class="pub_div pub_title_box">
				<div class="left_box">
					<h3>特惠景点门票</h3>
					<p>最开心的旅游应该是没有后顾之忧的，一票在手，说走就走。</p>
				</div>
				<div class="right_box"><a href="/cn/ticket" class="more">查看全部门票</a></div>
			</div>
			<div class="pub_div ticket_box">
				<div class="item" v-for="(item,index) in ticketList" :key="index">
					<a :href="'/cn/ticket/detail?Id='+item.TicketId" target="_blank" :title="item.Title">
					<div class="picture">
						<img :src="item.Picture" />
					</div>
					<div class="txt">
						<h3>{{truncatedMessage(item.Title,32)}}</h3>
						<div class="location">{{replaceTxt(item.Location)}}</div>
					</div>
					</a>
				</div>
			</div>
		</div>
		<!--门票-结束-->
		
		<!--Why-开始-->
		<div class="why_div">
			<div class="pub_div why_box">
				<h3>为什么选择檀岛旅游网？</h3>
				<div class="items">
					<div class="item">
						<div class="icon one"></div>
						<div class="txt">
							<h4>产品特点</h4>
							<p>檀岛旅游深耕30年，拥有众多合作合约及行业人脉，汇聚资深导游、各类型旅游巴士等一手资源，实现真正一站式服务。</p>
						</div>
					</div>
					<div class="item">
						<div class="icon two"></div>
						<div class="txt">
							<h4>专业定制</h4>
							<p>檀岛旅游深耕夏威夷多年，专业团队服务，熟悉当地资源，行程设计灵活，品质值得信赖。</p>
						</div>
					</div>
					<div class="item">
						<div class="icon three"></div>
						<div class="txt">
							<h4>公正透明</h4>
							<p>坚持公平透明、纯玩无购物，精选优质行程与服务，让游客玩得放心、体验舒心、选择更安心。</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--Why-结束-->
		
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import Swiper from "swiper"
	import "swiper/css/swiper.min.css"
	import {
		getHomeData,
		checkToken,
	} from '@/api/index.js'
	import { mixin } from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	export default {
		name: 'CN_Index',
		mixins:[mixin],
		components: {
			cnHeader,
			cnFooter,
		},
		data() {
			return {
				fullscreenLoading: true, //loading状态
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				keyword: '',
				tips:'请在左侧输入您要检索的内容',
				
				homeDetail: {},
				bannerList: [],
				productList:[],
				recreationList:[],
				hotelList:[],
				faqList:[],
				partnerList:[],
				ticketList:[],

			}
		},
		mounted() {
			// 计算轮播项宽度
			this.$nextTick(() => {
				const container = this.$refs.carouselContainer;
				if (container) {
					this.itemWidth = container.offsetWidth / 3;
				}
			});
		},
		created() {
			
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
				}
				this.getData()
			},
			// 获取数据列表
			async getData ()
			{
				this.homeDetail = []
				const { data: res } = await getHomeData(this.language, this.terminal)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.homeDetail = res.data
					this.getBanner(this.homeDetail.BannerList)
					this.productList = this.homeDetail.ProductList
					this.recreationList = this.homeDetail.RecreationList
					this.hotelList = this.homeDetail.HotelList
					this.faqList = this.homeDetail.FaqList
					this.ticketList = this.homeDetail.TicketList
				} else {
					this.$message.error(res.errmsg);
				}
			},
			// 获取轮播图
			getBanner (arr) {
				this.bannerList = arr
				this.$nextTick(() => {
					let times = setTimeout(() => {
						clearTimeout(times);
						this.getSwiper();
					}, 300);
				});
			},
			getSwiper() {
				var swiper = new Swiper(".mySwiper", {
					spaceBetween: 30,
					effect: "fade",
					loop: false,
					autoplay: {
						delay: 5000,
						stopOnLastSlide: false,
						disableOnInteraction: false, //在用户交互后继续自动轮播
					},
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
					on: {
						slideChange: function(event) {
							// console.log(this.activeIndex)
						},
						click: (event) => {},
					},
				});
			},
			//搜索
			searchHandle()
			{
				if(this.keyword == '')
				{
					this.$refs.keyword.focus()
					return
				}
				
				//跳转至搜索结果页
				this.$router.push({
					path: '/cn/search?keyword='+encodeURIComponent(this.keyword)
				})
			}
		},
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;

		/*重置公共头部菜单投影*/
		::v-deep .header .main_div .navigate_menu {
			box-shadow: 0px 1px 5px #444;
		}

		::v-deep .header .main_div .basic_div .right .menu {
			box-shadow: 0px 1px 5px #444;
		}


		h1.title {
			font-size: 28px;
			font-weight: 500;
			text-align: center;
		}
		.ext_title {
			width: 95%;
			margin: 20px auto 0 auto;
			text-align: center;
			font-size: 13px;
		}

		.space_txt {
			position: relative;
			margin-top: 50px;
			height: 56px;
			background-image: url(@/assets/images/icons/space_line.png);
			background-position: center;
			background-repeat: no-repeat;
			text-align: center;

			.txt {
				margin: 0 auto;
				display: inline-block;
				padding: 0 40px;
				background: #fff;
				color: #999;
				text-align: center;
				font-size: 14px;
				line-height: 56px;
				font-weight: 300;
			}
		}

		.banner {
			width: 100%;
			height: 390px;
			background: #f8f8f8;
			position: relative;
			
			.swiper-cont {
				width: 100%;
				height: 390px;
				overflow: hidden;
				position: relative;
			
				.swiper-slide {
					width: 100%;
					height: 100%;
					text-align: center;
					
					.slogan {
						width: 100%;
						position: absolute;
						top: 40%;
	
						h1 {
							font-size: 60px;
							font-weight: 600;
							color: #fff;
							text-shadow: 3px 3px 15px #555;
							height: 70px;
							line-height: 70px;
						}
	
						h4 {
							margin-top: 10px;
							font-size: 15px;
							font-weight: 500;
							color: #fff;
							text-shadow: 1px 1px 3px #555;
						}
					}
			
					.img-cont {
						width: 100%;
						height: 100%;
						background-position: center;
						background-repeat: no-repeat;
						background-size: auto 100%;
						object-fit: cover;
					}
				}
			
				.swiper-slide:nth-child(2n) {
					.img-cont {
						background-color: #99a9bf;
					}
				}
			
				.swiper-slide:nth-child(2n + 1) {
					.img-cont {
						background-color: #7bb7fc;
					}
				}
				
				.swiper-pagination {
				}
			}

		}
		
		@media (min-width: 2000px) {
			.banner {
				width: 100%;
				height: 520px;
				
				.swiper-cont {
					width: 100%;
					height: 520px;
				}
			}
		}
		
		/*搜索*/
		.search_box {
			width: 100%;
			height: 190px;
			box-sizing: border-box;
			background-color: #EFF3F7;
			background-image: url(@/assets/images/hgh_search_bg.png);
			background-repeat: no-repeat;
			background-position: center;
			background-size: 100% 100%;
			padding-top: 46px;
			
			h3 {
				font-size: 28px;
				font-weight: 500;
				text-align: center;
			}

			.search {
				width: 800px;
				height: 60px;
				margin: 24px auto 0 auto;
				box-sizing: border-box;
				border: #ccc solid 1px;
				background: #fff;
				border-radius: 30px;
				display: flex;
				justify-content: space-between;

				::placeholder {
					color: #888;
					font-size: 18px;
					line-height: 60px;
					font-weight: 400;
				}

				.place {
					width: 100%;
					height: 60px;
					padding-left: 30px;
				}
				
				/deep/ .el-input {
					border: 0;
					padding: 0;
					width: 95%;
					font-size: 18px;
				}				
				
				/deep/ .el-input__inner {
					height: 58px;
					line-height: 58px;
					padding: 0;
					background-image: none;
					font-size: 18px;
					font-weight: 400;
					border-radius: 0;
				}

				.button {
					width: 60px;
					height: 60px;
					margin-right: 6px;
					background-image: url(@/assets/images/hgh_search.png);
					background-repeat: no-repeat;
					background-position: center;
					background-size: 24px 24px;
					cursor: pointer;
					opacity: .7;
					-webkit-transition: all .3s ease;
				}

				.button:hover {
					opacity: 1;
				}
			}
		}

		/*每块区域公共头部*/
		.pub_title_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			
			.left_box {
				line-height: 150%;
				h3 {
					font-size: 28px;
					font-weight: 500;
				}
				p {
					margin-top: 10px;
					font-size: 13px;
					color: #666;
				}
			}
			.right_box {
				a.more {
					display: block;
					height: 40px;
					line-height: 40px;
					border-radius: 20px;
					padding: 0 20px;
					background-color: #fff;
					border: #3D7856 solid 1px;
					-webkit-transition: all .3s ease;
					color: #3D7856;
					font-size: 15px;
					font-weight: 500;
				}
				a.more:hover {
					background-color: #3D7856;
					color: #fff;
				}
			}
		}
		
		/*套餐*/
		.product_div {
			width: 100%;
			background-color: #fff;
			padding: 50px 0 30px 0;
		}
		.product_box {
			margin-top: 30px;
			display: flex;
			flex-wrap: wrap;
			
			
			.item {
				width: 320px;
				margin-bottom: 30px;
				margin-right: 23px;
				
				a {
					position: relative;
				}
				
				h4 {
					margin-top: 8px;
					font-size: 16px;
					font-weight: 500;
				}
				p {
					margin-top: 4px;
					font-size: 13px;
				}
				
				.tips {
					position: absolute;
					z-index: 1000;
					left: 10px;
					top: 10px;
					background-color: #fff;
					height: 26px;
					line-height: 26px;
					font-size: 14px;
					font-weight: 500;
					padding: 0 10px;
					border-radius: 5px;
					opacity: .95;
				}
				
				img {
					width: 100%;
					height: 213px;
					display: block;
					border-radius: 20px;
					-webkit-transition: all .3s ease;
					position: relative;
					overflow: hidden;
				}
			}
			.item:nth-child(4n) {
				margin-right: 0;
			}
			
			.item:hover {
				img {
					border-radius: 20px;
					transform: scale(1.02);
					-webkit-transform: scale(1.02);
				}
			}
		}
		
		/*玩乐*/
		.recreation_div {
			width: 100%;
			box-sizing: border-box;
			background-color: #F1F6FD;
			padding: 50px 0 30px 0;
		}
		.recreation_box {
			margin-top: 30px;
			display: flex;
			flex-wrap: wrap;
			
			.item {
				width: 250px;
				margin-bottom: 30px;
				margin-right: 24px;
				background-color: #fff;
				border-radius: 20px;
				box-shadow: 1px 1px 5px #ddd;
				padding-bottom: 10px;
				-webkit-transition: all .3s ease;
				
				a {
					position: relative;
				}
				
				h4 {
					padding: 4px 10px 2px 10px;
					font-size: 14px;
					font-weight: 500;
				}
				p {
					padding: 0 10px;
					font-size: 12px;
					color: #333;
				}
			}
			.item:nth-child(5n) {
				margin-right: 0;
			}
			.item:hover {
				margin-top: -8px;
				box-shadow: 0px 0px 10px #bbb;
			}
		}
		
		/*酒店*/
		.hotel_div {
			width: 100%;
			box-sizing: border-box;
			background-color: #fff;
			padding: 50px 0 30px 0;
		}
		.hotel_box {
			margin-top: 30px;
			display: flex;
			flex-wrap: wrap;
			
			.item {
				width: 243px;
				margin: 0 33px 30px 0;
				position: relative;
				overflow: hidden;
				cursor: pointer;
						
				.picture {
					width: 243px;
					height: 162px;
					background: #000;
					border-radius: 20px;
					position: relative;
					overflow: hidden;
						
					img {
						width: 100%;
						opacity: .6;
						border-radius: 20px;
						-webkit-transition: all 1s ease;
					}
				}
						
				.title {
					font-size: 15px;
					font-weight: 500;
					line-height: 140%;
					text-align: center;
					padding: 10px 10px 0 10px;
				}
			}
			.item:nth-child(5n) {
				margin-right: 0;
			}
						
			.item:hover {
						
				img {
					border-radius: 20px;
					transform: scale(1.1);
					-webkit-transform: scale(1.1);
					opacity: 1;
				}
			}
		}
		
		/*门票*/
		.ticket_div {
			width: 100%;
			box-sizing: border-box;
			background-color: #F8F4FD;
			padding: 50px 0 30px 0;
		}
		.ticket_box {
			margin-top: 30px;
			display: flex;
			flex-wrap: wrap;
			
			.item {
				width: 320px;
				height: 104px;
				box-sizing: border-box;
				margin: 0 23px 23px 0;
				border-radius: 8px;
				background: #fff;
				border: #CED6DE solid 1px;
				-webkit-transition: all .3s ease;
				
				a {
					display: flex;
					justify-content: left;
					align-items: center;
				}
			
				.picture {
					width: 135px;
					height: 102px;
					position: relative;
					overflow: hidden;
					border-top-left-radius: 8px;
					border-bottom-left-radius: 8px;
			
					img {
						width: 135px;
						height: 102px;
						display: block;
						border-top-left-radius: 8px;
						border-bottom-left-radius: 8px;
						transform: scale(1);
						-webkit-transform: scale(1);
						-webkit-transition: all .5s ease;
					}
				}
			
				.txt {
					width: 185px;
					height: 102px;
					box-sizing: border-box;
					padding: 10px 12px;
					position: relative;
			
					h3 {
						font-size: 13px;
						line-height: 150%;
						font-weight: 500;
					}
			
					.location {
						position: absolute;
						bottom: 10px;
						font-size: 12px;
						line-height: 12px;
						color: #333;
					}
				}
			}
			.item:nth-child(4n) {
				margin-right: 0;
			}
			
			.item:hover {
				background: #fff;
				box-shadow: 0 0 8px #bbb;
			
				h3 {
					text-decoration: underline;
				}
			
				img {
					border-radius: 5px;
					transform: scale(1.1);
					-webkit-transform: scale(1.1);
				}
			}
		}
		
		/*为什么选择檀岛旅游*/
		.why_div {
			width: 100%;
			box-sizing: border-box;
			background-color: #fff;
			padding: 70px 0 30px 0;
		}		
		.why_box {
			
			h3 {
				font-size: 28px;
				font-weight: 500;
				text-align: center;
			}
			
			.items {
				display: flex;
				justify-content: space-between;
				align-items: center;
				flex-wrap: wrap;
				margin-top: 50px;
				
				.item {
					width: 430px;
					height: 120px;
					padding: 20px;
					box-sizing: border-box;
					background-color: #EFF4FC;
					border-radius: 8px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					
					.icon {
						width: 70px;
						height: 70px;
						background-position: center;
						background-repeat: no-repeat;
						background-size: 100% 100%;
					}
					.one {
						background-image: url(@/assets/images/hgh_why_1.png);
					}
					.two {
						background-image: url(@/assets/images/hgh_why_2.png);
					}
					.three {
						background-image: url(@/assets/images/hgh_why_3.png);
					}
					
					.txt {
						width: 74%;
						
						h4 {
							font-size: 18px;
							font-weight: 500;
						}
						p {
							margin-top: 6px;
							font-size: 13px;
							line-height: 160%;
						}
					}
				}
			}
		}
	}
</style>

<style scoped>
	/deep/ .swiper-pagination-bullet {
		background-color: rgba(0, 0, 0, 0);
		width: 50px;
		height: 8px;
		opacity: .5;
		border-radius: 4px;
		background-color: #333;
	}

	/deep/ .swiper-pagination-bullet-active {
		background-color: #fff;
		opacity: .8;
	}
	
	/deep/ .el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
		border: 0;
	}
	
	/deep/ .el-date-editor .el-range-separator {
		line-height: 40px;
		color: #999;
		margin-right: 20px;
	}
	/deep/ .el-range-input {
		text-align: left;
	}
	
	/deep/ .el-input__icon {
		width: 0;
		display: none;
	}
	
	/deep/ .el-input {
		height: 36px;
		line-height: 36px;
		border: 0;
		padding: 0;
	}
	/deep/ .el-input__inner {
		padding: 0;
		background-image: none;
		font-weight: 400;
	}
</style>